export default __webpack_public_path__ + "static/media/moki@2x.4cf9a4e3.png";